<script lang="ts">
	import { format } from 'svelte-i18n';
	import { push } from 'svelte-spa-router';
	import { Text, ButtonV2, InputV3, Icon } from '@Shelly/shelly-design-system';

	let finish = false;
</script>

{#if !finish}
	<Text element="h1" class="mb-l pl-s"
		>{$format('title_change_email', { default: 'Change E-mail' })}</Text
	>

	<InputV3
		id="input-new-email"
		aria-labelledby="input-new-email"
		size="l"
		class="mb-m"
		label={$format('text_new_email', { default: 'New E-mail' })}
		type="email"
	/>

	<InputV3
		id="input-confirm-new-email"
		aria-labelledby="input-confirm-new-email"
		size="l"
		class="mb-m"
		label={$format('text_confirm_new_email', { default: 'Confirm New E-mail' })}
		type="email"
	/>

	<InputV3
		id="input-enter-password"
		aria-labelledby="input-enter-password"
		size="l"
		class="mb-m"
		label={$format('text_enter_password', { default: 'Enter Password' })}
		type="password"
		a11yProps={{
			iconButtonAriaLabel: $format('button_show_password', {
				default: 'Show password',
			}),
		}}
	/>

	<ButtonV2
		class="mb-m"
		variant="primary"
		width="full"
		on:click={() => {
			finish = true;
		}}
	>
		{$format('button_save', { default: 'Save' })}
	</ButtonV2>

	<ButtonV2
		variant="secondary"
		width="full"
		on:click={() => {
			push('/email-verification');
		}}
	>
		{$format('button_cancel', { default: 'Cancel' })}
	</ButtonV2>
{:else}
	<div class="text-center mb-m">
		<Icon icon="fat fa-thumbs-up text-success" size="l" />
	</div>
	<Text element="h1" class="text-center mb-m pl-s">
		{$format('text_email_changed_success', {
			default: 'E-mail Changed Successfully.',
		})}
	</Text>
	<Text class="text-center mb-m">
		{$format('text_verify_new_email', {
			default: 'Please Verify your new e-mail.',
		})}
	</Text>
	<ButtonV2
		width="full"
		on:click={() => {
			push('/email-verification');
		}}
	>
		{$format('button_verify_email', { default: 'Verify E-mail' })}
	</ButtonV2>
{/if}
